import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { NavBarComponent } from '../nav-bar/nav-bar.component';

@Component({
    selector: 'app-website',
    standalone: true,
    imports: [CommonModule, FooterComponent, RouterOutlet, NavBarComponent],
    templateUrl: './website.component.html',
    styleUrl: './website.component.sass',
})
export class WebsiteComponent {}
